<!-- Badge completo -->
<div
  *ngIf="!soloIcono"
  class="estado-badge"
  [ngClass]="getEstadoClass(idEstado)">
  <mat-icon>{{ getEstadoIcon(idEstado) }}</mat-icon>
  <span>{{ getEstadoDescripcion(idEstado) }}</span>
</div>

<!-- Solo ícono -->
<mat-icon
  *ngIf="soloIcono"
  class="estado-icon"
  [ngClass]="getEstadoClass(idEstado)"
  [matTooltip]="getEstadoDescripcion(idEstado)"
  matTooltipPosition="right">
  {{ getEstadoIcon(idEstado) }}
</mat-icon>
